module.exports = __webpack_public_path__ + "img/9788952771827.b1d2640f.jpg";